import sopLibraryTemplate from "./sop_library.html";
import en from "./en.json";
import es from "./es.json";

export default {
    bindings: {
        grower: "<",
        topics: "<",
    },
    template: sopLibraryTemplate,
    name: "sopLibrary",
    translations: { en, es },
};
